import { cmeDisclaimerDialogConfig } from "@features/cme/constants";
import { AppBar } from "@features/dashboard/layouts/AppBar";
import { handleNavigateBack } from "@helpers/common";
import Box from "@memorang/ui/components/Box";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";
import DocumentTitle from "components/DocumentTitle";

const CMEDisclaimerRoute = () => {
	return (
		<>
			<DocumentTitle title={cmeDisclaimerDialogConfig.title} />
			<AppBar
				title={cmeDisclaimerDialogConfig.title}
				onPressBack={() => handleNavigateBack("/cme")}
			/>
			<ScrollContainer maxWidth="sm">
				<Box padding={16}>
					<CustomMarkdownRenderer text={cmeDisclaimerDialogConfig.body} />
				</Box>
			</ScrollContainer>
		</>
	);
};

export default CMEDisclaimerRoute;
